var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5804 5.14437C19.3706 4.29993 18.6713 3.59622 17.8322 3.38511C16.2238 2.96289 10 2.96289 10 2.96289C10 2.96289 3.70629 2.96289 2.16783 3.38511C1.32867 3.59622 0.629371 4.29993 0.41958 5.14437C-0.13986 8.38141 -0.13986 11.6184 0.41958 14.8555C0.629371 15.6999 1.32867 16.4036 2.16783 16.6147C3.70629 17.037 10 17.037 10 17.037C10 17.037 16.2937 17.037 17.8322 16.6147C18.6713 16.4036 19.3706 15.6999 19.5804 14.8555C20.1399 11.6888 20.1399 8.38141 19.5804 5.14437ZM7.97203 13.0259V6.974L13.1469 9.99993L7.97203 13.0259Z",
    fill: "#0D111A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.819f96f7.svg";
export { ForwardRef as ReactComponent };